import { render, staticRenderFns } from "./OpenForwardedOrders.vue?vue&type=template&id=35228f54"
import script from "./OpenForwardedOrders.vue?vue&type=script&lang=js"
export * from "./OpenForwardedOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports